import Cookies from "universal-cookie";
import { queryClient } from "~/plugins/vue-query";
import { authService } from "~/utils/api/authService";
import {
  deleteLoggedAsAdmin,
  readLoggedAsAdmin,
} from "~/utils/adminCookiesCRUD";

const VITE_API_HOST = import.meta.env.VITE_API_HOST;
const loggedInCookie = `is_logged_in_${VITE_API_HOST}`;

const cookies = new Cookies();
let logOutTimeout: ReturnType<typeof setTimeout> | null = null;
const sessionExpiredTime =
  typeof localStorage !== "undefined" && localStorage.getItem("rememberMe")
    ? 31556926
    : 7200;

const clearLogOutTimeout = () => {
  if (logOutTimeout !== null) {
    clearTimeout(logOutTimeout);
  }
};

let isLoggingOut = false;

const setLogOutTimeout = () => {
  const timeout = setTimeout(
    () => {
      clearLogOutTimeout();
      logOutTimeout = null;
      if (!isLoggingOut) {
        logUserOut({ redirect: false });
        window.location.href = "/login?timeout=true";
      }
    },
    // 10000,
    sessionExpiredTime * 1000 - 1000,
  );
  logOutTimeout = timeout;
};

export const createLoggedIn = () => {
  cookies.set(loggedInCookie, "true", {
    path: "/",
    maxAge: sessionExpiredTime,
  });
  setLogOutTimeout();
};

export const readLoggedIn = () => {
  return cookies.get(loggedInCookie);
};

export const updateLoggedIn = () => {
  if (readLoggedIn()) {
    createLoggedIn();
  } else {
    clearLogOutTimeout();
  }
};

export const deleteLoggedIn = () => {
  clearLogOutTimeout();
  cookies.remove(loggedInCookie, { path: "/" });
};

export const logUserOut = async ({ redirect = true } = {}) => {
  // Zabezpieczenie przed wielokrotnym wywoływaniem
  if (isLoggingOut) {
    console.log("Logout already in progress, skipping...");
    return;
  }

  isLoggingOut = true;

  try {
    if (readLoggedIn()) {
      deleteLoggedIn();
      // Verify if the cookie is actually removed
      if (readLoggedIn()) {
        console.warn("Cookie was not removed, retrying...");
        deleteLoggedIn();
        if (readLoggedIn()) {
          console.error("Failed to remove cookie after retrying.");
        } else {
          console.log("Cookie successfully removed after retrying.");
        }
      } else {
        console.log("Cookie successfully removed.");
      }

      try {
        await authService.logout();
      } catch (error) {
        console.error("Logout API call failed:", error);
      }

      try {
        queryClient.removeQueries();
      } catch (error) {
        console.error("Query client cleanup failed:", error);
        // Nie przerywamy procesu wylogowania
      }
    }

    if (readLoggedAsAdmin()) {
      deleteLoggedAsAdmin();
      console.log("Admin cookie removed.");
    }

    if (redirect) {
      try {
        window.location.href = "/login";
      } catch (error) {
        console.error("Redirect failed:", error);
        // Fallback - spróbuj użyć router jeśli dostępny
        if (typeof navigateTo !== "undefined") {
          navigateTo("/login");
        }
      }
    }
  } finally {
    setTimeout(() => {
      isLoggingOut = false;
    }, 1000);
  }
};
export { loggedInCookie };
